import styled from "@emotion/styled"
import TextsWrapper from "components/Texts/TextsWrapper"

const TextSevenWrapper = styled(TextsWrapper)``

export default TextSevenWrapper
